<div class="typeahead-component-wrapper">
    <mat-form-field>
        <mat-label>Type to Search</mat-label>
        <input
            matInput
            placeholder="{{ placeholder() ?? 'Type to search' }}"
            aria-label="Search"
            [matAutocomplete]="auto"
            [formControl]="displayFormControl"
            [readOnly]="disabled()"
            [matAutocompleteDisabled]="disabled()"
            #searchInput />
        <mat-autocomplete
            #auto="matAutocomplete"
            class="typeahead-results"
            (optionSelected)="onResultSelection($event)">
            @for (result of searchResults(); track $index) {
                <mat-option [value]="result" [disabled]="result.disabled">
                    @if (searchResultIcons()[$index]) {
                        <fa-icon [icon]="['fas', searchResultIcons()[$index]?.icon!]" />
                    }
                    {{
                        resultDisplayPropertyPath()
                            ? (getDescendantProp | apply: result : resultDisplayPropertyPath())
                            : result
                    }}
                    <!-- {{ searchResults() | json }} -->
                </mat-option>
            }
        </mat-autocomplete>
        @if (valueFormControl.errors?.['required']) {
            <mat-error>Value required</mat-error>
        }
    </mat-form-field>
</div>
